import { apiClient } from './client';
import { FavoritesResponse } from '../../types';

export const favoritesApi = {
  // Get all favorites
  getFavorites: async (params?: {
    include_details?: boolean;
    sort?: 'custom' | 'name' | 'recent';
  }): Promise<FavoritesResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.include_details !== undefined) {
      queryParams.append('include_details', params.include_details.toString());
    }
    if (params?.sort) {
      queryParams.append('sort', params.sort);
    }

    const queryString = queryParams.toString();
    const endpoint = queryString ? `/api/mobile/favorites?${queryString}` : '/api/mobile/favorites';

    return apiClient.get(endpoint);
  },

  // Add favorite
  addFavorite: async (
    marketId: number,
    options?: {
      custom_label?: string;
      color_tag?: string;
      display_order?: number;
    }
  ): Promise<{ id: number; market_id: number; added_at?: string }> => {
    return apiClient.post(`/api/mobile/favorites/${marketId}`, options);
  },

  // Remove favorite
  removeFavorite: async (marketId: number): Promise<void> => {
    return apiClient.delete(`/api/mobile/favorites/${marketId}`);
  },

  // Update favorite order
  updateFavoriteOrder: async (marketId: number, displayOrder: number): Promise<void> => {
    return apiClient.put(`/api/mobile/favorites/${marketId}/order`, {
      display_order: displayOrder,
    });
  },
};
